module.exports = __webpack_public_path__ + "img/物联网.5e2c1f41.png";